import numeral from 'numeral'
import { CustomerLead } from '../../../core/domain/customerLead.model'
import { OfferData } from '../../../core/domain/offerData.model'
import {
  OfferDocumentDTO,
  PriceDTO,
} from '../../../core/domain/offerDocument.dto'
import AgentService from '../../../core/services/agent.service'
import customerService from '../../../core/services/customer.service'
import OfferService from '../../../core/services/offer.service'
import {
  clearOfferDocumentId,
  clearToken,
  clearUserName,
  getOfferDocumentId,
} from '../../../core/services/storage.service'
import { LifecyclePresenter } from '../../_components/ConnectComponent'
import { AdobeEventManager } from '../../_utils/adobeAnalytics'
import { dataLayer, s_Layer } from '../../_utils/adobeAnalytics/adobeAnalytics.conf'
import { getDefaultLanguage } from '../../_utils/i18next'
import { goToHelvetiaLandingPage } from '../../_utils/links'
import { generalConditions, mountDownablePDF } from '../../_utils/pdfs/pdf'
import { redirectionProvider } from '../ContractRedirection.provider'
import { policyViewMapper } from './Policy.mapper'
import { PolicyRaw, View } from './Policy.view'

export class PolicyPresenter implements LifecyclePresenter<View> {
  private view!: PolicyRaw
  protected offer: OfferData
  protected document: OfferDocumentDTO
  protected customer: CustomerLead
  protected obtainedPrice: PriceDTO
  protected totalSum: number = 0

  initialize(view) {
    this.view = view
  }

  onLifecycleStart = async () => {
    dataLayer.page.category.applicationStep = 'step10-policy-contract-summary'
    AdobeEventManager.emit('policy_contract', 'calc_step')

    await this.getOfferDocument()

    AdobeEventManager.emit('policy_added', 'add_product')

    this.view.setInitialValues(
      policyViewMapper(this.offer, this.document, this.customer),
      this.customer.informedTermsAndConditions,
      this.obtainedPrice,
      Boolean(this.document.contractingDate),
    )
  }

  getOfferDocument = async () => {
    try {
      this.document = await OfferService.getOfferDocument(getOfferDocumentId())

      this.offer = this.document.offerData
      this.customer = this.document.customerLead

      this.obtainedPrice = await OfferService.getOfferPrice()
    } catch (error) {
      console.log(error)
    }
  }

  onContract = async (informedTermsAndConditions?: boolean) => {
    const customer = this.setFormValues(informedTermsAndConditions)


    try {
      await customerService.saveCustomer(customer)
      await OfferService.saveOfferData(this.offer)
      await OfferService.contract()

      const { insuredVehicle1, insuredVehicle2, insuredVehicle3, insuredVehicle4, insuredVehicle5 } = this.offer
      this.totalSum = insuredVehicle1 + insuredVehicle2 + insuredVehicle3 + insuredVehicle4 + insuredVehicle5

      dataLayer.product.productInfo.productInsuranceSum = numeral(this.totalSum).format('0,0.00')
      dataLayer.product.productInfo.productDeductible = numeral(
        this.offer.deductible,
      ).format('0,0.00')
      dataLayer.product.productInfo.productInsurancePremium = numeral(
        this.obtainedPrice.price + this.obtainedPrice.taxes,
      ).format('0,0.00')
      dataLayer.product.productInfo.productCategory =
        'Carriers liability policy contract'
      dataLayer.products = `;Carriers Liability;1;${this.obtainedPrice.price + this.obtainedPrice.taxes};;eVar53=${this.totalSum}|eVar58=${this.offer.deductible}`

      AdobeEventManager.emit('policy_contract_thanks', 'calc_thanks')
      this.onShowViewModal()
    } catch (error) {
      console.log(error)
    }
  }

  setFormValues = (informedTermsAndConditions?: boolean) => {
    return Object.assign(this.customer, {
      informedTermsAndConditions:
        !AgentService.isAgentOrBroker() && informedTermsAndConditions
          ? informedTermsAndConditions
          : true,
    })
  }

  onShowGeneralConditionPDF = () => {
    let pdf = generalConditions[getDefaultLanguage()]
    dataLayer.event.eventInfo.fileDownload = pdf
    window.open(pdf, '_blank')

    AdobeEventManager.emit(
      'policySummary_download_general_conditions_pdf',
      'file_downloads',
    )
  }

  onShowViewModal = () => this.view.showModal()


  onHideModalHandler = () => {
    this.view.hideModal()
    clearOfferDocumentId()
    clearToken()
    if (AgentService.isAgentOrBroker()) {
      this.view.props.history.push('/portal')
    } else {
      // this.view.props.history.push('/home')
      clearUserName()
      this.view.showLoading()
      goToHelvetiaLandingPage()
    }
  }

  onBack = () => {
    OfferService.saveOfferData(this.offer).then(() => {
      this.view.props.history.push(
        redirectionProvider.redirectToPreviousStep('policy-summary'),
      )
    })
  }

  onBackToPortal = () => {
    OfferService.saveOfferData(this.offer).then(() => {
      this.view.props.history.push('/portal')
    })
  }

  onDownloadOfferPDF = async () => {
    this.view.showLoading()

    try {
      let pdf = await OfferService.getOfferPDF(getOfferDocumentId())
      mountDownablePDF(pdf, this.document.offerNumber, true)

      AdobeEventManager.emit(
        'policy_summary_download_policy_pdf',
        'file_downloads',
      )

      this.view.hideLoading()
    } catch (error) {
      console.log(error)

      this.view.hideLoading()
      alert('It is NOT available to get PDF for your query')
    }
  }
}
